export const paymentTypeOptions = [
  { value: 0, name: "بطاقة" },
  { value: 1, name: "تحويل بنكي" },
];
